import { render, staticRenderFns } from "./Manutd-94-95-Away.vue?vue&type=template&id=25e9cfc8&"
import script from "./Manutd-94-95-Away.vue?vue&type=script&lang=js&"
export * from "./Manutd-94-95-Away.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports